// Shell integration: define the child states under the 'prod-authoring-settings-ui' state from the shell
//					  all states should use dot notation to become children of the parent shell state

module.exports = ['$stateProvider', function($stateProvider) {

	$stateProvider.
		// Default
		state('prod-authoring-homepage-ui.root', {
			url: '',
			template: '<homepage-main-container></homepage-main-container>',
			data: {
				helpPage: {
					editor: 'SS3UMF/dch/admin/manager/editor/home_editor.html',
					manager: 'SS3UMF/dch/admin/manager/home_manager.html',
					admin: 'SS3UMF/dch/admin/home_admin.html'
				},
				actionbar: {actions: [{
					id: 'hubInfo',
					title: 'Hub info',
					icon: '#hubInfoIcon',
					type: 'button',
					handleClick: function() { angular.element(window).trigger('WCH_HUB_INFO') }
				}]}
			},
			params: {
				paagTab: null,
				about: false
			}
		}).
		state('prod-authoring-about-ui.root', {
			url: '',
			template: '<homepage-main-container></homepage-main-container>',
			data: {
				helpPage: {
					editor: 'SS3UMF/dch/admin/manager/editor/home_editor.html',
					manager: 'SS3UMF/dch/admin/manager/home_manager.html',
					admin: 'SS3UMF/dch/admin/home_admin.html'
				},
				actionbar: {actions: [{
					id: 'hubInfo',
					title: 'Hub info',
					icon: '#hubInfoIcon',
					type: 'button',
					handleClick: function() { angular.element(window).trigger('WCH_HUB_INFO') }
				},{
					id: 'privacyNotice',
					title: 'Privacy notice',
					icon: '#privacyNoticeIcon',
					type: 'button',
					handleClick: function() { angular.element(window).trigger('WCH_USER_PREFS') }
				}]}
			},
			params: {
				paagTab: null,
				about: true
			}
		});
}];



// WEBPACK FOOTER //
// ./app/components/mainContainer/mainContainer.config.js